(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["puffit-hero"] && !Shopify.designMode) return;
  try {
    
  // 视频开始播放后，淡出外部 poster 层，避免黑屏/封面残留
  (function() {
    var medias = document.querySelectorAll('[data-hero-media]');
    medias.forEach(function(wrap) {
      var poster = wrap.querySelector('.puffit-hero__poster');
      if (!poster) return;
      var video = wrap.querySelector('video');
      if (!video) return;

      var hidePoster = function() {
        poster.style.opacity = '0';
      };

      video.addEventListener('playing', hidePoster, { once: true });
      if (video.readyState >= 2 && !video.paused) hidePoster();
      wrap.addEventListener('video:playing', hidePoster);
    });
  })();

  // 监听Shopify标准弹窗/抽屉事件，给body添加标记，触发上移动画
  document.addEventListener('shopify:modal-open', () => document.body.classList.add('popup-open'));
  document.addEventListener('shopify:modal-close', () => document.body.classList.remove('popup-open'));
  document.addEventListener('shopify:drawer-open', () => document.body.classList.add('drawer-open'));
  document.addEventListener('shopify:drawer-close', () => document.body.classList.remove('drawer-open'));

  } catch(e) { console.error(e); }
})();
})();
